// extracted by mini-css-extract-plugin
export default {"CoreValues_container":"CoreValues_CoreValues_container__3jFfl","ValueCard_container":"CoreValues_ValueCard_container__wGBco"};